'use client';

import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

const getFeeOptions = (feeOptions) =>
	feeOptions.map(({ id, feesHistory }) => {
		const productCode = feesHistory[0]?.productCode?.code || '';
		const rateCode = feesHistory[0]?.rateCode?.code || '';
		if (!productCode || !rateCode) return { key: '', value: '' };
		return {
			key: id,
			value: `${productCode} / ${rateCode}`,
		};
	});

const getFeeValue = (monthlyFee): { key: string; value: string } => {
	if (!monthlyFee?.feesHistory?.length || !monthlyFee.feesHistory[0].productCode) return { key: '', value: '' };
	return {
		key: monthlyFee.id,
		value: `${monthlyFee.feesHistory[0].productCode.code} / ${monthlyFee.feesHistory[0].rateCode.code}`,
	};
};

export const AccessDeviceCodeAutoComplete = ({ id, handleChange, feeOptions, selectedFee, disabled, error }) => (
	<Autocomplete
		options={getFeeOptions(feeOptions)}
		value={getFeeValue(selectedFee)}
		freeSolo
		disabled={disabled}
		size='medium'
		isOptionEqualToValue={(option, value) => option.key === value.key}
		getOptionLabel={(option) => {
			if (typeof option === 'string') return '';
			return option.value;
		}}
		renderOption={(props, option) => (
			<li {...props} key={`${id}-${option.key}`}>
				{option.value}
			</li>
		)}
		renderInput={(params) => (
			<TextField
				{...params}
				value={selectedFee?.id || ''}
				inputProps={{ ...params.inputProps, 'data-cy': id }}
				error={error}
			/>
		)}
		onChange={handleChange}
	/>
);
